import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton, Tooltip } from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

import { useTypedSelector } from "../../hooks.tsx";
import { streamAsk } from "../search/streamAsk.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { RootState } from "../../store/types.tsx";
import { conversationActions } from "../../store/conversation.tsx";

interface ExplainPromptProps {
  exchange_id: string | undefined;
}

const ExplainPrompt: React.FC<ExplainPromptProps> = (props) => {
  const dispatch = useDispatch();
  const isAuthenticated = useTypedSelector(
    (state) => state.authState.isLoggedIn,
  );
  const selectedModel = useSelector(
    (state: RootState) => state.conversationState.selectedModel,
  );

  const userStoppedStream = useSelector(
    (state: RootState) => state.conversationState.userStoppedStream,
  );
  const stopStreamRef = useRef<(() => void) | null>(null);

  const stopAnimation = () => {};

  const handleOnClick = async () => {
    await streamAsk({
      dispatch,
      isAuthenticated,
      stopAnimation,
      exchangeURL: "/v1/explain/begin/",
      streamSlug: "/v1/stream_ask/",
      exchangeParams: {
        prompt: "",
        exchange_id: props.exchange_id || "",
        model: selectedModel,
      },
      stopStreamRef,
    });
  };

  useEffect(() => {
    if (stopStreamRef.current) {
      try {
        stopStreamRef.current();
      } catch (error) {
        console.error("Failed to stop streaming:", error);
      }
      stopStreamRef.current = null;
      dispatch(conversationActions.setUserStoppedStream(false));
    }
  }, [userStoppedStream]);

  return (
    <Box>
      <Tooltip
        title={i18n._(
          msg({
            context:
              "Button title urging the user to explain why the provided answer wasn't satisfactory.",
            message: "Explain",
          }),
        )}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.9rem",
            },
          },
        }}
      >
        <IconButton onClick={handleOnClick} size="small">
          <HelpOutlineOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ExplainPrompt;
